const EMBED_ORIGIN_URL_KEY = 'embed-origin-url';
export const getEmbedOriginUrlFromSessionStorage = () => {
  try {
    return sessionStorage.getItem(EMBED_ORIGIN_URL_KEY) || '';
  } catch (e) {
    return '';
  }
};
export const removeEmbedOriginUrlFromSessionStorage = () => {
  try {
    sessionStorage.removeItem(EMBED_ORIGIN_URL_KEY);
  } catch (e) {
    return;
  }
};